import React from 'react';

const LockOpen = ({ className = '', title = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="39"viewBox="0 0 28 39">
      <title lang="en">{title}</title>
      <rect x="1.5" y="16.5" width="25" height="21" fill="none" stroke="#54322B" strokeWidth="3" strokeLinejoin="round" />
      <circle cx="14" cy="26" r="4" fill="#54322B" />
      <path d="M14,26L14,26c1.1,0,2,0.9,2,2v3c0,1.1-0.9,2-2,2l0,0c-1.1,0-2-0.9-2-2v-3C12,26.9,12.9,26,14,26z" fill="#54322B" />
      <path d="M5.9,6c1.7-2.7,4.7-4.5,8.1-4.5c5.2,0,9.5,4.3,9.5,9.5v5.5h-19" fill="none" stroke="#54322B" strokeWidth="3" />
    </svg>
  )
};

export default LockOpen;
